export default
{
  'entities': {
    'save': 'Uložit',
    'saved': 'Uloženo',
    'error': 'Chyba',
    'send': 'Odeslat',
    'add': 'Přidat',
    'edit': 'Upravit',
    'close': 'Zavřít',
    'czech': 'Čeština',
    'english': 'Angličtina',
    'yes': 'Ano',
    'no': 'Ne',
    'loading': 'Načítání...',
    'download': 'Stáhnout',
    'export': 'Exportovat',
    'list': 'Seznamy základních entit',
    'couldnt_save': 'Data se nepodařilo uložit.',
    'couldnt_save_server': 'Při ukládání nastala chyba serveru.',
    'back': 'Zpět',
    'entity_portal': 'Portál entit',
    'study_faculties' : 'Správa studijního oddělení',
    'required': 'Povinná položka',
    'confirm_deletion': 'Určitě chcete smazat tento záznam?',
    'successfull_request': 'Úspěšně odesláno',
    'result_not_found': 'Výsledek nenalezen',
    'no_data': 'Nepodařilo se nám získat žádná data, zkuste to prosím později.',
    'detail': 'Detail',
    'section_in_progress': 'Táto sekce se připravuje.',
    'loadAll': 'Načíst vše',
    'description_cz': 'Popis',
    'description_en': 'Description',
    'alert': 'Upozornit',
    'not_alert': 'Neupozornit',
    'uploaded_images': 'Nahrané fotky',
    'max_one_image': 'Je možné nahrát maximálně 1 obrázek',
    'invalidDimensions':'Obrázek musí mít minimální rozměry',
    'saving': 'Ukládání..',
    'image_uploading': 'Probíhá nahrávání obrázků',
    'language_notice': 'Některé moduly jsou dostupné pouze v češtině',
    'logout': 'Odhlásit se',

    'study_types': {
      'weekly_type': 'Dálkové studium',
      'weekly_type_short': 'Dálkové',
      'daily_type': 'Prezenční studium',
      'daily_type_short': 'Prezenční',
      'other_type': 'Jiné',

      'Bachelor': 'Bakalářské studium',
      'Bachelor_short': 'Bakalářské',
      'Master': 'Magisterské studium',
      'Master_short': 'Magisterské',
      'Doctoral': 'Doktorské studium',
      'Doctoral_short': 'Doktorské',
      'Other': 'Jiné',

      'study': 'Studium',
    },

    'assistants': {
      //Edit
      'portal_name': 'Portál studijních referentek',
      'detail_study_ref': 'Detail studijní referentky',
      'ref_name': 'Jméno studijní referentky',
      'type_ref_name': 'Napište jméno studijní referentky.',
      'door_num': 'Číslo  kanceláře',
      'door_num_required': 'Uveďte číslo kanceláře.',
      'Xlogin': 'Login do UISu',
      'xlogin_required': 'Uveďte přihlašovací jméno do UISu, např. xpisarov',
      'Xlogin_type': 'UIS login, např. xpisarov',
      'ref_assign': 'Přiřazení studijní referentky',
      'no_study_ref_assigned': 'Bez přiřazení',
      'not_assigned_study_ref': 'U studijních oborů zatím není přiřazena studijní referentka.',
      'study_ref_not_assigned': 'Studijní referentka zatím nebyla přiřazena k žádným studijním oborům.',
      'remove_study_ref': 'Vymazat studijní referentku',
      'name_required': 'Uveďte jméno.',
      'name_too_short': 'Název musí být delší než 5 znaků.',
      'confirm_deletion': 'Určitě chcete smazat tento záznam?',
      'confirm_deletion_with_save': 'Určitě chcete smazat tento záznam? (Nutno následně uložit.)',
      'faculty_assign':'Přiřazení fakulty',
      "faculty": "Fakulta",
      "faculty_required": "Zvolte fakultu",
      //Portal
      'no_study_ref': 'Žádné studijní referentky',
      //New Assistant
      'new_study_ref': 'Nová studijní referentka',
    },

    'reasons': {
      //Edit
      'portal_name': 'Portál restrikcí',
      'reason_type': 'Důvod restrikce',
      'type_reason_type': 'Vyberte důvod restrikce.',
      'reason_name': 'Název restrikce',
      'type_reason_name': 'Napište název restrikce.',
      'reason_name_en': 'Anglický název restrikce',
      'type_reason_name_en': 'Napište anglický název restrikce.',
      'code_required': 'Uveďte kód.',
      'code_too_short': 'Kód musí být delší než 5 znaků.',
      'name_required': 'Uveďte jméno.',
      'name_too_short': 'Jméno musí být delší než 5 znaků.',
      'reasons_edit': 'Úprava důvodu restrikce',
      'reasons_detail': 'Detail důvodu restrikce',
      'confirm_deletion': 'Určitě chcete smazat tento záznam?',
      //Portal
      'no_reasons_set': 'Žádné důvody restrikcí',
      //New
      'new_reason': 'Nový důvod restrikce',
      'person': 'Osobní',
      'department': 'Oddělení',
      'reasons_delete': 'Vymazat restrikční důvod',
    },

    'studyfield': {
      //New
      'portal_name': 'Portál studijních oborů',
      'new_study': 'Nový studijní obor',
      'study_code': 'Kód oboru',
      'type_study_code': 'Napište kód oboru',
      'study_name': 'Název oboru',
      'type_study_name': 'Napište název oboru',
      'study_name_en': 'Název oboru – anglicky',
      'type_study_name_en': 'Napište název oboru',
      'study_deg': 'Stupeň studia',
      'type_study_deg': 'Zvolte stupeň studia',
      'study_form': 'Forma studia',
      'type_study_form': 'Zvolte formu studia',
      'target_languages': 'Zobrazit pouze v jazycích',
      'select_target_languages': 'Vyberte jazyky',
      'assign_ref' : 'Vyberte studijní referentku',
     'new_ref' : 'Přiřazení studijní referentky',

      //Edit
      'ref_edit': 'Úprava studijní referentky',
      'detail_edit': 'Úprava studijního oboru',
      'detail': 'Detail studijního oboru',
      'study_refs': 'Přiřazené studijní referentky',
      'no_study_refs': 'Nemáte přiřazené žádné studijní referentky',
      'delete_study_field': 'Vymazat studijní obor',
      'confirm_deletion': 'Určitě chcete smazat tento záznam?',
      //Portal
      'no_studyfield_refs': 'Žádné studijní obory.',
    },

    'openHours': {
      'portal_name': 'Portál otevíracích hodin',
      'openHours_edit_panel': 'Úprava otevíracích hodin pro dotykový panel',
      'openHours_edit_mobile': 'Úprava otevíracích hodin pro mobilní aplikaci',
      'from': 'od',
      'to': 'do',
      'pause': 'pauza',
      'description': 'Popis otevíracích hodin',
      'no_description' : 'Neobsahuje popis otevíracích hodin',
      'cz': 'Český popisek',
      'en': 'Anglický popisek'
    },

    'studyProblems': {
      'portal_name': 'Portál kategorií studijních požadavků',
      'new_study': 'Nová kategorie studijního požadavku',
      'category_name': 'Název kategorie',
      'type_category_name': 'Napište název kategorie.',
      'category_name_en': 'Anglický název kategorie',
      'type_category_name_en': 'Napište název kategorie.',
      'category_code': 'Kód kategorie',
      'type_category_code': 'Napište kód kategorie.',
      'study_type': 'Forma studia',
      'type_study_type': 'Zvolte formu studia.',
      //Edit
      'detail_edit': 'Úprava kategorie studijního požadavku',
      'category_detail': 'Detail kategorie studijního požadavku',
      'del_req': 'Vymazat studijní požadavek',
      'study_req': 'Studijní požadavky',
      'add_req': 'Přidat požadavek',
      'no_study_req': 'Zatím nemáte přiřazené žádné studijní požadavky.',
      'no_study_category': 'Žádné kategorie studijních požadavků.',
    },

    'studyItem': {
      'portal_name': 'Portál studijních požadavků',
      'studyItem_edit': 'Úprava kategorie studijního požadavku',
      'new_studyItem': 'Nový studijní požadavek',
      'req_name': 'Název požadavku',
      'type_req_name': 'Napište název požadavku',
      'req_name_en': 'Název požadavku – anglicky',
      'type_req_name_en': 'Napište anglický název požadavku.',
      'req_category': 'Kategorie požadavků',
      'type_req_category': 'Zvolte kategorii požadavků.',
      'req_code': 'Kód požadavku',
      'type_req_code': 'Napište kód požadavku.',
      'length': 'Odhadovaný čas trvání',
      'description': 'Popis',
      'type_description': 'Uveďte popis.',
      'description_en': 'Anglický popis',
      'type_description_en': 'Napište anglický popis.',
      //Edit
      'edit_study_req': 'Úprava studijního požadavku',
      'study_req_detail': 'Detail studijního požadavku',
      'del_req': 'Vymazat studijní požadavek',
      //Portal
      'no_study_req': 'Žádné studijní požadavky.',
    }
  },

  'checkIn': {
    //Dialogs
    'break': 'Přestávka',
    'new_break': 'Nová přestávka',
    'time': 'Přibližný čas nepřítomnosti:',
    'message': 'Zpráva, která se zobrazí čekajícím (nepovinné):',
    'stop_checkIn': 'Ukončit odbavování',
    'close': 'Zavřít',
    'start': 'Spustit',
    'checkIn_confirm': 'Určitě chcete ukončit odbavování?',
    'pick_study': 'Vyberte studijní referentku, ke které chcete požadavek',
    'pick_priority': 'prioritně delegovat',
    'pick_study_select': 'Vyberte studijní referentku',
    'no_go_back': 'Tato akce je nenávratná, kliknutím na delegovat souhlasíte se změnou',
    'no_go_back_cont': 'a budete přesměrováni na výběr požadavku.',
    //CheckIn
    'que_waiting': 'Ve frontě čekají:',
    'no_waiting': 'Ve frontě aktuálně nikdo nečeká.',
    //DidCome
    'being_served': 'Odbavován',
    'scheduled_time': 'Objednán na',
    'stop': 'Ukončit',
    'anon_student': 'Anonymní student',
    //DidNah
    'not_served': 'Neodbaven',
    //Fallback
    'waiting': 'Čekáme',
    'reset': 'Resetovat',
    'or': 'nebo',
    'no_waiting_hold': 'Ve frontě aktuálně nikdo není, čekáme na studenty.',
    //NextInLine
    'next_in_line': 'Je na řadě:',
    'doing': 'Vyřizuje se',
    'call_in': 'Vyvolat',
    //Pause
    'on_break': 'Běží přestávka.',
    'stop_break': 'Ukončit',
    'break_time': 'Přestávka již trvá',
    'break_duration': 'Přestávka byla zvolena na',
    'minutes': '{n} minutu | {n} minuty | {n} minut',
    //Start
    'calling': 'Vyvolávání',
    'start_message': 'Spuštěním se aktivuje vyvolávací panel, který vyzve první tiket v pořadí.',
    //Turn
    'wating_for': 'Čekáme na',
    'waiting_left': 'zbývá čekat',
    'student_did_not_come': 'Student nepřišel, můžete ještě počkat nebo přejít na vyvolání dalšího. ',
    'sec' : '{n} sekunda | {n} sekundy | {n} sekund',
    'arrived': 'Přišel',
    'hasnt_arrived': 'Nepřišel',
  },
  'reservations': {
    //Calendar
    'today': 'Dnes',
    'study': '{n} studijní | {n} studijní | {n} studijních',
    'personal': '{n} osobní | {n} osobní | {n} osobních',
    'res_calendar': '{n} rezervace | {n} rezervace | {n} rezervací',
    'calendar': 'Rezervační kalendář',
    'my_calendar': 'Moje Kalendáře',
    'Master': 'Magisterský',
    'Bachelor': 'Bakalářský',
    'Other': 'Jiný',
    'res_ref': 'Rezervace k vyřízení požadavků',
    'restrict_ref': 'Nahlášené restrikce v úředních hodinách',
    'restrict_pef': 'Úplné restrikce studijního oddělení PEF',
    //infobar
    'study_restrictions': 'Studijní restrikce',
    'no_study_restrictions_day': 'Na tento den nejsou nahlášené žádné restrikce studijního oddělení.',
    'personal_restrictions': 'Osobní restrikce',
    'no_personal_restrictions': 'Na tento den nemáte nahlášené žádné vlastní restrikce.',
    'reservations': 'Rezervace',
    'no_reservations': 'Na tento den nemáte nahlášené žádné rezervace',
    'show_history': 'Zobrazit historii',
    'hide_history': 'Skrýt historii',
    'add_reservation': 'Přidat rezervaci',
    'add_restriction': 'Přidat restrikci',
    'anon_student': 'Anonymní student',
    'we_closed': 'Máme zavřeno.',
    //Dialogs
    'choose_req': 'Zvolte požadavek',
    'pick_req_ref': 'Výběr požadavku ke studijní referentce',
    'pick_req_cat': 'Vyberte kategorii požadavku',
    'pick_confirm': 'Vyberte konkrétní potvrzení',
    'close': 'Zavřít',
    'add': 'Vložit',
    'pick_type_field': 'Zvolte typ studia a obor.',
    'pick_study_type': 'Zvolte typ studia',
    'pick_study_field': 'Zvolte studovaný obor',
    //Children
    'create_new_res': 'Vytvoření nové rezervace',
    'save': 'Uložit',
    'res_saved': 'Rezervace uložena',
    'res_saved_id': 'Rezervace je uložena pod identifikačním číslem:',
    'res_not_save': 'Rezervace nebyla uložena',
    'res_not_save_error': 'Při ukládání došlo k chybě. Zkontrolujte požadovaný čas a volné časové sloty.',
    'ok': 'OK',
    'if_you_want': 'Pokud skutečně chcete v tomto čase vytvořit rezervaci, zvolte Ano. V opačném případě zvolte Zrušit',
    'cancel_unsuccesful_modal': 'Zrušit',
    'yes': 'Ano',
    'res_date': 'Datum rezervace',
    'pick_res_date': 'Vyberte datum',
    'res_person': 'Student/Klient',
    'type_res_person': 'Napište jméno a příjmení.',
    'xname': 'UIS login',
    'type_ticket': 'Stav požadavku',
    'assigned_assistant': 'Přiřazená studijní referentka',
    'type_xname': 'Napište UIS login.',
    'res_stud_field': 'Typ studia a obor',
    'request': 'Požadavek',
    'add_request': 'Přidat požadavek',
    'timespan_request': 'Časové vymezení vyřízení',
    'timespan_default_time': 'Zvolte čas/výchozí trvání události',
    'time_length': 'Přibližná délka trvání:',
    'time_from': 'Čas od',
    'untill': 'do',
    'time_to': 'Čas do',
    'req_note': 'Soukromá poznámka',
    'req_note_no_stud': 'Nezobrazuje se studentovi',
    'timeslots_free': 'Volné časové sloty',
    'timeslots_from': 'od',
    'timeslots_to': 'do',
    'timeslots_no_free': 'Nemáte žádné volné sloty',
    'name_required': 'Uveďte jméno',
    'name_length': 'Jméno musí být delší než 2 znaky.',
    'date_required': 'Zadejte datum.',
    'xname_format': 'Login musí mít aspoň 2 znaky, pouze malá písmena a čísla.',
    'time_required': 'Zadejte čas.',
    //Detail
    'res_detail_calendar': 'Detail rezervace v rezervačním kalendáři',
    'edit': 'Upravit',
    'ticket_id': 'Tiket ID',
    'res_status': 'Status rezervace',
    'assistant': 'Přiřazená studijní referentka',
    'not_served': 'Neodbaven',
    'cancel_user': 'Zrušen uživatelem',
    'cancel_study_ref': 'Zrušen studijní referentkou',
    'served': 'Odbaven',
    'next_in_line': 'Na řadě',
    'no_notes': 'Nemáte žádnou poznámku',
    'other': 'Jiné',
    //Edit
    'res_editing': 'Úprava vytvořené rezervace',
    'res_changed': 'Rezervace byla změněna.',
    'res_not_saved': 'Úprava rezervace nebyla uložena.',
    'res_couldnt_saved': 'Rezervaci se nepodařilo uložit.',
    'res_delete': 'Vymazat rezervaci',
    'confirm_deletion': 'Určitě chcete smazat tento záznam?',
    //Restrictions
    'restrict_calendar': 'Vytvoření nové restrikce v kalendáři rezervací',
    'restrict_agend': 'Agenda, které se restrikce týká',
    'person': 'Osoba',
    'stud_dep_pef': 'Studijní oddělení PEF',
    'restrict_reason': 'Důvod restrikce',
    'restrict_date': 'Datum restrikce',
    'restrict_time': 'Časová platnost restrikce',
    'whole_day': 'Celá úřední doba',
    'specific_timespan': 'Konkrétní časové vymezení',
    'experiment': 'Pozor, experimentální funkce! Nedoporučujeme mít více omezení ve stejné nebo překrývající se časy.',
    'restrict_meetings': 'Rezervované schůzky, kterých se restrikce týká',
    'no_restrict_meetings': 'Žádné rezervace ve vybraném termínu',
    'item_required': 'Prvek je požadován.',
    'longterm_action': 'Dlouhodobá akce',
    'delegation': 'Delegovat na:',
    'delegation_to': 'Delegováno na',
    //Detail
    'restrict_detail': 'Detail restrikce v rezervačním kalendáři',
    'restrict_reason_change': 'Důvod změny',
    'cancel': 'Zrušit',
    'delegate': 'Delegovat',
    'study_department': 'Studijní oddělení',
    //Edit
    'restrict_edit': 'Úprava vytvořené restrikce',
    'restrict_delete': 'Vymazat restrikci',
    'restriction_saved': "Restrikce upravena",
    'restriction_changed_succ': "Restrikce byla změněna.",
    'restriction_not_saved': "Restrikce nebyla uložena.",
    'restriction_not_save_error': "Při ukládaní došlo k chybě."

  },
  'queueManagement': {
    not_an_assistant: 'Máte práva pro přístup k modulu, ale zatím jste nebyl(a) nastavena jako asitent(ka) vedoucím studijního oddělení.',
    'reservations': 'Rezervace',
    'checkins': 'Odbavování',
    'stats': 'Statistiky',
    'default_entities': 'Základní entity',
  },

  'support': {
    'headline': 'Problémy a nápady',
    'message_type_input': 'Typ zprávy',
    'email_input': 'E-mail',
    'description_input': 'Popis',
    'file_drop_text': 'Přetáhněte soubory nebo klikněte',
    'file_drop_text_hover': 'Pusťte soubory pro nahrání',
    'file_delete_confirm': 'Opravdu chcete smazat tento soubor natrvalo?',
    'uploaded_files': 'Nahrané soubory',
    'files_to_be_uploaded': 'Soubory k nahrání',
    'file_will_be_deleted': 'bude smazán',
    'urgent_checkbox': 'Řešení spěchá (označte jen pokud jde o naléhavý požadavek)',
    'email_input_invalid': 'E-mail musí být ve správném formátu',
    'have_question': 'Mám otázku',
    'have_idea': 'Mám nápad',
    'have_problem': 'Mám problém',
    'invalidFileType': 'Soubor musí být ve formátu',
    'fileTooBig': 'Příliš velký soubor',
    'or': 'nebo',
  },

  'onboarding': {
    'no_questions': 'Pro tuhle lokalitu nejsou žádné otázky.',
  },

  'gamification': {
    'subjects': 'Předměty',
    'subject': 'Předmět',
    'add_subject': 'Přidat předmět',
    'archive_subject': 'Archivovat předmět',
    'archive': 'Archivovat',
    'edit_subject': 'Úprava předmětu',
    'subject_name': 'Název předmětu',
    'subject_code': 'Kód předmětu',
    'subject_code_info': ' Zadejte jedinečný kód předmětu podle oficiálního označení na MENDELU (např. VA2).\n' +
        'Kód slouží k jednoznačné identifikaci předmětu v systému a při administrativních úkonech.',
    'subject_icon': 'Ikona předmětu',
    'delete': 'Odstranit',
    'does_not_exist': 'neexistuje',
    'delete_title_dialog': 'Potvrdit smazání?',
    'delete_warning_dialog': 'Změny nebude možné vrátit.',
    'confirm_archive_subject': 'Předmět zmizí ze seznamu. Výsledky, docházka a hodnocení studentů zůstanou zachovány.',
    'cancel': 'Zrušit',
    'save': 'Uložit',
    'edit': 'Upravit',
    'loading': 'Načítání',
    'search_subject': 'Hledat předmět..',
    'name': 'Název',
    'code': 'Kód',
    'admin': 'Správce',
    'action': 'Akce',
    'selected': 'vybraný',
    'no_subjects': 'Žádné předměty',
    'no_subjects_added': 'Zatím nebyly přidány žádné předměty',
    'no_data': 'Žádná dostupná data',
    'academics': 'Akademici',
    'search_academics': 'Hledat akademika..',
    'show_academics_selected': 'Zobrazit pouze vybrané akademiky',
    'academic_gam_profile_info': 'Tento akademik zatím nemá účet pro gamifikaci. Pro jeho založení prosím doplňte potřebné údaje. Bez účtu nelze akademika přiřadit k předmětu.',
    'add_academic': 'Přidat akademika',
    'academics_lead': 'Vyberte akademiky, kteří mohou semináře vést.',
    'academics_ids_error': 'Vložený login nepatří tomuto uživateli. Neshodují se UIS id.',
    'login_error': 'xlogin neexistuje',
    'general_error': 'Chyba. Zkuste to prosím znovu.',
    'connection_error': 'Chyba s připojením',
    'more_icons': 'Další ikony',
    'hide_icons': 'Skrýt ikony',
    'edit_selection': 'Upravit výběr',
    'fullname': 'Jméno a přijmení',
    'enter_login': 'Zadat xlogin',
    'add': 'Přidat',
    'seminars': 'Semináře',
    'seminar': 'Seminář',
    'add_seminar': 'Přidat seminář',
    'create_seminar': 'Vytvořit seminář',
    'new_seminar': 'Nový seminář',
    'seminar_name': 'Název semináře',
    'search_seminar': 'Hledat seminář..',
    'no_seminars': 'Žádné semináře',
    'no_seminars_added': 'Zatím nebyly přidány žádné semináře',
    'semester': 'Semestr',
    'winter_semester': 'Zimní semestr',
    'summer_semester': 'Letní semestr',
    'current_semester': 'aktuální',
    'history_read_only': 'Historické období — data jsou pouze pro čtení.',
    'score': 'Skóre',
    'test_date': 'Datum odevzdání',
    'configuration': 'Konfigurace',
    'activate_features_info': 'Aktivujte požadované funkce pro tento seminář.',
    'enable_qr_info': 'Zapnutím přepínačů umožníte vygenerování QR kódu, který během výuky ukážete studentům. Ti si jej načtou přes aplikaci Moje MENDELU, čímž se jim zaznamená docházka a mohou vyplnit test a evaluaci (v závislosti na tom, co všechno aktivujete).',
    'generate_qr_code': 'Vygenerovat QR kód',
    'regenerate_qr_title': 'Přegenerovat QR kód?',
    'regenerate_qr_warning': 'Seminář už má test, ke kterému se někdo připojil. Vygenerování nového QR kódu se dotkne:',
    'regenerate_qr_participants': 'přihlášených studentů: {count}',
    'regenerate_qr_submissions': 'odevzdaných testů: {count}',
    'regenerate_qr_kept': 'Záznamy se nesmažou, jen se odloží do historie. V semináři je ale už neuvidíte. Seminář dostane nové QR kódy a předchozí přestanou platit.',
    'regenerate_qr_confirm': 'Přegenerovat',
    'click_to_view_preview': 'Kliknutím zobrazíte náhled',
    'attendance_and_evaluation': 'Docházka a evaluace',
    'attendance_date': 'Datum zapsání docházky',
    'star_count': 'Počet hvězd',
    'rating': 'Hodnocení',
    'update': 'Aktualizovat',
    'attendance': 'Docházka',
    'evaluation': 'Evaluace',
    'attendance_activated': 'Docházka aktivována',
    'evaluation_activated': 'Evaluace aktivována',
    'test_activated': 'Test aktivovaný',
    'test_not_started': 'Test nespuštěný (spuštění v záložce "Testy" níže)',
    'test_started': 'Test spuštěný',
    'start_test': 'Spustit test',
    'stop_test': 'Zastavit test',
    'time_remaining': 'Zbývá',
    'full_name': 'Jméno',
    'rank': 'Pořadí',
    'points': 'Body',
    'success_rate': 'Úspěšnost',
    'submitted_at': 'Odevzdáno',
    'completed': 'Dokončeno',
    'cancelled': 'Zrušeno',
    'status': 'Stav',
    'connected': 'Připojený/á',
    'disconnected': 'Odpojený/á',
    'in_progress': 'V procesu',
    'submitted': 'Odevzdáno',
    'not_submitted': 'Neodevzdáno',
    'error': 'Chyba',
    'no_info': 'Žádné info',
    'user_status': 'Stav uživatelů',
    'no_users_available': 'Žádní uživatelé k dispozici',
    'search_user': 'Hledat uživatele..',
    'users': 'Uživatelé',
    'users_genitive': 'uživatelů',
    'test_results': 'Výsledky testu',
    'test': 'Test',
    'tests': 'Testy',
    'add_test': 'Přidat test',
    'create_new_test': 'Vytvořit nový test',
    'search_test': 'Hledat test..',
    'edit_test': 'Úprava testu',
    'select_test': 'Vybrat test',
    'test_selection': 'Výběr testu',
    'want_separate_qr_for_test': 'Chci mít samostatný QR kód na test',
    'separate_test': 'Samostatný test',
    'separate_test_info': 'Pokud chcete studenty testovat např. na začátku výuky a docházku s evaluací zaznamenat až na jejím konci, QR kód pro test si můžete nechat vygenerovat zvlášť.',
    'test_duration_min': 'Doba trvání testu (min)',
    'advanced_test_settings': 'Pokročilé nastavení testu',
    'submission_grace_label': 'Tolerance odevzdání',
    'join_window_label': 'Okno pro připojení',
    'unit_seconds': 's',
    'unit_minutes': 'min',
    'default_value_hint': 'Výchozí: {value} {unit}',
    'leave_empty_for_default': 'Ponechte prázdné pro výchozí nastavení',
    'window_out_of_range': 'Zadejte hodnotu mezi {min} a {max}',
    'join_window_longer_than_test': 'Okno pro připojení nemůže být delší než doba trvání testu',
    'no_tests': 'Žádné testy',
    'no_tests_added': 'Zatím nebyly přidány žádné testy',
    'test_name': 'Název testu',
    'test_icon': 'Ikona testu',
    'test_one_question': 'Test musí obsahoval minimálně jednu otázku.',
    'questions': 'Otázky',
    'question': 'Otázka',
    'title_select_questions': 'Výběr otázek',
    'add_another_question': 'Přidat jinou otázku',
    'question_list_empty': 'Seznam otázek je prázdný',
    'can_create_new_question': 'Můžete vytvořit novou otázku',
    'create_question': 'Vytvořit otázku',
    'save_selection': 'Uložit výběr',
    'newest': 'Od nejnovější',
    'oldest': 'Od nejstarší',
    'alphabetical': 'Abecedně',
    'last_changes': 'Poslední změny',
    'created_by': 'Vytvořil/a',
    'created': 'Vytvořeno',
    'add_question': 'Přidat otázku',
    'search_question': 'Hledat otázku..',
    'question_type': 'Typ otázky',
    'question_count': 'Počet otázek',
    'no_questions': 'Žádné otázky',
    'no_questions_added': 'Zatím nebyly přidány žádné otázky',
    'new_question': 'Nová otázka',
    'question_help_text': 'Při vytváření dotazů se můžete pohybovat pomocí kláves Tab nebo Shift+Tab.',
    'question_text': 'Text otázky',
    'required': 'Povinné',
    'options': 'Možnosti',
    'option': 'Možnost',
    'yes': 'Ano',
    'no': 'Ne',
    'have_question': 'Mám otázku',
    'dashboard_welcome_title': 'Vítejte v modulu Mendeluj!',
    'dashboard_welcome_subtitle': 'Vytvořte pro své studenty vědomostní testy.',
    'login': 'Login',
    'type_of_question': 'Typ otázky',
    'one_right_answer': 'Jedna správná odpověď',
    'multiple_right_answers': 'Více správných odpovědí',
    'true_false': 'Pravda/Nepravda',
    'to_subjects_btn': 'Přejít na předměty',


    'tutorial_heading': 'Návod k používání',
    'allow':'Povolit',
    'not_allow':'Nepovolit',
    'adding_subject_headline': '1. Přidání předmětu',
    'creating_questions_headline': '2. Tvorba otázek',
    'creating_test_headline': '3. Vytvoření testu',
    'creating_seminar_headline': '4. Vytvoření semináře',
    'seminar_activation_headline': '5. Aktivace semináře',
    'adding_subject_paragraph': 'Vytvořte předměty, které vyučujete.\n'+ 'Zadejte xloginy všech zaměstnanců, kteří budou předmět spravovat.',
    'creating_questions_paragraph': 'Vytvářejte a upravujte otázky různých typů (jedna správná, více správných odpovědí, pravda/nepravda). Otázky můžete opakovaně využívat v různých testech zvoleného předmětu.',
    'creating_test_paragraph': 'U vybraného předmětu vytvořte nový test, přiřaďte mu otázky. Testy lze kdykoli upravit, pokud nejsou aktivní.',
    'creating_seminar_paragraph': 'Založte seminář spojený s vybraným předmětem. U každého semináře můžete zapnout docházku, přidat test nebo umožnit evaluaci. Lze využít libovolnou kombinaci těchto funkcí.',
    'seminar_activation_paragraph': 'Po aktivaci je nutné nasdílet studentům QR kód, který využijí k zadání docházky, evaluace nebo připojení do čekárny testu. Test jako takový je nutné spustit samostatně.',
    'privacy_policy_headline': 'Zásady ochrany osobních údajů',
    'privacy_policy_paragraph': 'Souhlasím se zpracováním svých osobních údajů Mendelovou univerzitou v Brně za účelem vedení výsledků ve vědomostních testech a dalších funkcí aplikace My MENDELU. Podrobné informace o zpracování osobních údajů naleznete v',
    'privacy_policy_link': 'zásadách ochrany osobních údajů',
    'privacy_policy_settings': 'Souhlasím se zpracováním svých osobních údajů Mendelovou univerzitou v Brně za účelem vedení výsledků ve vědomostních testech a dalších funkcí aplikace My MENDELU.',
    'privacy_policy_link_settings': 'Více o zpracování osobních údajů (GDPR) na MENDELU',
    'save_settings': 'Uložit nastavení',
    'consent': 'Souhlas',
    'privacy_policy_settings_headline': 'Upravte si, jakým způsobem zpracováváme vaše údaje v rámci aplikace.',
    'privacy_policy_settings_button': 'Nastavení soukromí',

    'qr_code': 'QR kód testu',
    'badges_headline': 'Odznaky',
    'image': 'Obrázek',
    'badge_name': 'Název odznaku',
    'new_category': 'Nová kategorie',
    'edit_category': 'Úprava kategorie',
    'edit_badge': 'Úprava odznaku',
    'test_info': 'Chcete-li test uložit, musíte vyplnit potřebné informace o testu. Informace jsou vyplněny správně, pokud se barva varování změní z červené na zelenou a pokud se nezobrazí vykřičník.',
    'input_warning': 'Zadejte název pro oba jazyky',
    'test_question': 'Testová otázka',
    'add_new_answer': 'Přidat další odpověď',
  },

  'headers': {
    //Global
    'action': 'Akce',
    'edit': 'Upravit',
    'show': 'Zobrazit/Skrýt',
    'name': 'Jméno',
    'room': 'Místnost',
    //AssistantDetail - StudyFieldPortal
    'field_code': 'Kód oboru',
    'field_name': 'Název oboru',
    'field_name_en': 'Anglický název oboru',
    'study_deg': 'Stupeň studia',
    'study_form': 'Forma studia',
    'study_deg_form': 'Stupeň a forma studia',
    'assign': 'Přiřazení',
    //AssistantPortal
    'xlogin': 'UIS Login',
    'studyFieldIds': 'Přiřazené obory',
    'studyProblemItemIds': 'Přiřazené požadavky',
    'studyFaculty': 'Fakulta',
    //ReasonsPortal
    'restrict_reason': 'Důvod restrikce',
    'restrict_name': 'Název restrikce',
    'restrict_name_en': 'Anglický název restrikce',
    //StudyProblemsCategoryDetail
    'title': 'Název',
    'title_en': 'Anglický název',
    'code': 'Kód',
    'approx_time': 'Přibližný čas',
    //StudyProblemsItemPortal
    'category': 'Kategorie',
    'approx_time_mins': 'Přibližný čas (v minutách)',
    //PauseDialog
    'five_min': 'do 5 minut',
    'ten_min': 'do 10 minut',
    'fifteen_min': 'do 15 minut',
    //CheckInTable
    'ticket_id': 'Tiket ID',
    'request': 'Požadavek',
    'assistant': 'Studijní referentka',
    'time': 'Čas',
    'priority_action': 'Prioritní akce',
    //NewRestriction
    'date': 'Datum',
    'student': 'Student',
    'options': 'Možnost',
    'delegate': 'Delegováno',
    'sub_time': 'Náhradní čas',
    //EntitiesPortal
    'study_req_category_and_requests': 'Studijní požadavky a kategorie',
    'study_req_category_and_requests_text' : 'Přehled studijních požadavků a jejich kategorii',
    'open_hours': 'Otevírací hodiny',
    'open_hours_text' : 'Otevírací hodiny studijního oddělení a jejich úprava',
    'restrict_reasons': 'Důvody restrikce',
    'restrict_reasons_text' : 'Přehled důvodů restrikcií a jejich úprava ',
    'study_fields': 'Studijní obory',
    'study_fields_text' : 'Přehled studijních oborov a jejich úprava',
    'study_requests': 'Studijní požadavky',
    'statistics' : 'Statistiky',
    'statistics_text' : 'Statistiky rezervací a dalších dat studijního oddělení',
    'study_refs': 'Studijní referentky',
    'study_refs_text' : 'Přehled aktuálních studijních referentek a možnosti úpravy',
    'target_languages': 'Pro jazyky',
    'ref_count' : 'Počet referentek',
    'today_open' : 'Dnes otevřeno',
    'today_close' : 'Dnes zavřeno',
    'pause' : 'Pauza',
    'reservation_count' : 'Rezervace dnes celkem',

  },

  'days': {
    'Monday': 'Pondělí',
    'Tuesday': 'Úterý',
    'Wednesday': 'Středa',
    'Thursday': 'Čtvrtek',
    'Friday': 'Pátek',
    'Saturday': 'Sobota',
    'Sunday': 'Neděle',
  },

  'months': {
    'January': 'leden',
    'February': 'únor',
    'March': 'březen',
    'April': 'duben',
    'May': 'květen',
    'June': 'červen',
    'July': 'červenec',
    'August': 'srpen',
    'September': 'září',
    'October': 'říjen',
    'November': 'listopad',
    'December': 'prosinec'
  },

  'statistics': {
    'period': 'období',
    'interval': {
      'day': 'Posledních 24 hodin',
      'week': 'Poslední týden',
      'month': 'Poslední měsíc',
      'quarter': 'Poslední 3 měsíce',
      'half_year': 'Posledních 6 měsíců',
      'year': 'Poslední rok',
    },

    'acceptableUnits': {
      'hour_of_day': 'hodiny dne',
      'day_of_week': 'dny týdne',
      'day_of_month': 'dny měsíce',
      'week_of_month': 'týdny roku',
      'month_of_year': 'měsíce roku'
    },

    'show': 'Zobrazit',
    'enter': 'Vstoupit',
    'time_period': 'časové období',
    'busiest': 'nejvíce vytížené',

    'alert_info': {
        'period': 'Celkový počet rezervací za zvolené období',
        'busiest': 'Úhrn pracovní zátěže ve zvoleném období'
    },

    'detail_overview': 'Detailní přehled',
    'occupation': 'Vytíženost studijního oddělení',
    'reservation_total': 'Celkový počet rezervací',

    'reservation_count': 'Počet rezervací',

    'day_of_month': 'den v měsíci',

    'between': 'Mezi',
  },

  'confirms': {
    "delete_succesful": "Smazání proběhlo úspěšně.",
    "delete_unsuccesful": "Při smazání došlo k chybě."
  },

  errors: {
    insufficient_permissions: 'Nemáte práva, kontaktujte prosím vedoucího pracovníka.',
  },

  'map': {
    'generator': {
      'map': 'Mapa',
      'alert': 'Vyberte, místo které chcete zobrazit z nabídky nebo na něj klikněte v mapě.',
      'building_select': 'Oblast',
      'floor_select': 'Podlaží',
      'place_select': 'Místo',
      'iframe_code': 'Kód na vaše stránky',
      'copy': 'Kopírovat',
      'save_as_image': 'Stáhnout jako obrázek',
      'link_to_map': 'Odkaz na mapu',
      'open_map_tab': 'Otevřít odkaz v novém okně',
      'hide_HTML_code': 'Skrýt HTML kód',
      'show_HTML_code': 'Zobrazit HTML kód',
      'map_is_generating': 'Mapa se generuje',
      'bad_url': 'Zadané parametry URL obsahují chybu a mapu nelze zobrazit.',
      'contact': `<a class="white--text" href="https://moje.mendelu.cz/kontakt">Kontaktujte nás prosím.</a>`,
      'not_negative': 'Záporná velikost',
      'not_found': (ctx) => `Místo <code>${ctx.named('placeName')}</code> nebylo nalezeno.`,
      'bigger_map': 'ZVĚTŠIT MAPU',
      'big':'Velký (1920x1080)',
      'medium':'Střední (1280x720)',
      'small':'Malý (860x640)',
      'own':'Vlastní rozměry',
      'width_in_pixels':'Šířka v pixelech',
      'height_in_pixels':'Výška v pixelech',
      'cancel':'Zrušit',
      'export':'Exportovat'
    },
    'defaults': {
      'exterior': 'Exteriér',
      'no_name': 'Bez názvu'
    },
    'legend': {
      'building_name': (ctx) => `Budova ${ctx.named('building')}`,
      'floor_name': (ctx) => `, ${ctx.named('floor')}. patro`,
    }
  },

  'places': {
    'types': {
      'department': 'Oddělení',
      'office': 'Kancelář',
      'utility_room': 'Sklad',
      'study_room': 'Studovna',
      'cafeteria': 'Kantýna',
      'terrace': 'Terasa',
      'ticket_machine': 'Automat na lístky',
      'food_machine': 'Jídelní automat',
      'indoor_building': 'Vnitro budovy',
      'empty': 'Prázdný prostor',
      'transportation_stop': 'Zastávka MHD',
      'garden': 'Zahrada',
      'storage': 'Sklad',
      'boardroom': 'Zasedací místnost',
      'dormitory': 'Koleje',
      'water_machine': 'Pitná voda',
      'toilet_female': 'Dámské toalety',
      'floor': 'Podlaha',
      'gatehouse': 'Vrátnice',
      'toilet': 'Toaleta',
      'engine_room': 'Strojovna',
      'computer_kiosk': 'Počítačový kiosek',
      'sink': 'Dřez',
      'emergency_floor': 'Nouzový východ',
      'classroom_and_laboratory': 'Učebna a laboratoř',
      'copier': 'Kopírka',
      'outline': 'Obvod',
      'locker': 'Skříňka',
      'shaft': 'Šachta',
      'ground': 'Přízemí',
      'coatroom': 'Šatna',
      'stairs': 'Schody',
      'elevator': 'Výtah',
      'toilet_male': 'Pánské toalety',
      'walk': 'Chodník',
      'parking': 'Parkoviště',
      'wall': 'Zeď',
      'archive': 'Archiv',
      'cafe_machine': 'Kávový automat',
      'bistro': 'Bistro',
      'kitchen': 'Kuchyně',
      'garage': 'Garáž',
      'gate': 'Brána',
      'building': 'Budova',
      'library': 'Knihovna',
      'emergency_stairs': 'Nouzové schody',
      'trashcan': 'Odpadkový koš',
      'toilet_handicapped': 'Toaleta pro handicapované',
      'room': 'Pokoj',
      'pizzeria': 'Pizzerie',
      'publishing_house': 'Vydavatelství',
      'wine_shop': 'Vinárna',
      'garbage': 'Odpadky',
      'base': 'Obvod patra',
    }
  },

  'iotSensors': {
    "no_data":"Žádná data",
    'dashboardTitle': 'Smart University',
    'detail_back_button':'Seznam místností',
    'search': 'Jakou místnost hledáte?',
    'measurement_headline': 'Aktuální podmínky',
    'measurement_second_headline': 'Dostupný hardware',
    'degree_celsius': '°C',
    'free_pcs': 'Volné počítače',
    'projector': 'Projektor',
    'whiteboard': 'Bílá tabule',
    'floor': 'patro',
    'open': 'Otevřená',
    'close': 'Zavřená',
    'measurement_tech_list': 'Seznamy technologií',
    'pc_list': 'Seznam počítačů',
    'pc_occupied': 'Obsazený',
    'pc_not_occupied': 'Volný',
    'software_list': 'Seznam software',
    'search_software': 'Jaký software hledáte?',
    'search_pc': 'Jaký počítač hledáte?',
    'search_category': 'Jakou kategorii hledáte?',
    'no_match_for_software': 'Je nám líto, zde jsme žádný software nenašli. Zkuste vyhledat jiný.',
    'no_match_for_computer': 'Je nám líto, zde jsme žádný počítač nenašli. Zkuste vyhledat jiný.',
    'roomTypes': {
      'all_rooms': 'Všechny',
      'classroom_and_laboratory': 'Učebny a laboratoře',
      'study_rooms': 'Studovny',
      'pc_rooms': 'Místnosti s počítači',
    },
    'technology_types': {
      'pc_list': 'Seznam počítačů',
      'software_list': 'Seznam software',
    },
    'measurements': {
      'HUMIDITY': 'Vlhkost',
      'NOISE': 'Hluk',
      'LIGHT_INTENSITY': 'Intenzita světla',
      'OCCUPANCY': 'Obsazenost',
      'WINDOW_STATE': 'Okna',
      'TEMPERATURE': 'Teplota',
    },
    'measurement_icons': {
      'HUMIDITY': 'opacity',
      'NOISE': 'record_voice_over',
      'LIGHT_INTENSITY': 'emoji_objects',
      'OCCUPANCY': 'groups',
      'OCCUPANCY_PCS': 'meeting_room',
      'WINDOW_STATE': 'window',
      'TEMPERATURE': 'thermostat',
    },
    'alert': {
      'success': 'Hodnoty jsou v normě, budete se zde cítit dobře',
      'warning': 'Některé hodnoty nejsou výborné',
      'error': 'Hodnoty v této místnosti NEJSOU vhodné',
    }
    },
    'news': {
      "faculties": "Fakulty a součásti",
      "faculties_subtitle": "Vyberte fakultu nebo součást, pro kterou chcete spravovat informační panel",
      "no_faculties_permissions_text" : "Je nám líto, momentálně nemáte priřazená práva k žádným součastem.",
      "no_faculties_permissions_title" : "Žádná práva k součástem",
      "list_faculties": "Seznam součástí",
      "no_news_text" : "Zatím zde nebyli přidány žádné novinky.",
      "no_news_title" : "Žádné novinky",
      "news_title": "Nadpis novinky",
      "new_post": "Nový příspěvek",
      "posts": "Příspěvky",
      "concept": "Koncept",
      "published": "Uveřejněn",
      "archived": "Archivován",
      "users_and_permissions" : "Uživatelé a oprávnění",
      "users_and_permissions_subtitle" : "Vyberte uživatele, kterého chcete spravovat",
      "users_and_permissions_administration" : "Správa uživatelů a oprávnění",
      "new_user": "Nový uživatel",
      "news" : "Novinky",
      "uploading" : "Nahrávání příspěvku",
      "uploaded": "Nahráno",
      "additional_info": "Doplňující informace",
      "uploading_title" : "Nahrávání titulku",
      "uploading_additional" : "Nahrávání doplňkových obrázků",
      "no_users_text" : "Je nám líto, zde momentálně nejsou žádní uživatelé.",
      "no_users_title" :"Žádní uživatelé",
      "saved" : "Uloženo",
      "users_list": "Seznam uživatelů",
      "faculties_permissions": "Práva k součástem univerzity",
      "audiences_permissions": "Práva k cílovým skupinám",
      "remove_user": "ODSTRANIT UŽIVATELE",
      "something_went_wrong_title" : 'Něco se polámalo',
      "something_went_wrong_text" : 'Je nám líto, něco se pokazilo. Zkuste znovu načíst stránku.',
      "news_list": "Seznam příspěvků",
      "post": "Příspěvek",
      "additional_images": "Doplňkové obrázky",
      "images_title": "Obrázky",
      "further_information" : "Další informace",
      "links": "Odkazy",
      "contact_data": "Kontaktní údaje",
      "post_targeting": "Cílení příspěvku",
      "post_topic": "Téma příspěvku",
      "target_groups": "Cílové skupiny",
      "target_parts": "Cílové současti",
      "publication": "Uveřejnění",
      "publish_post": "Uveřejnit příspěvek",
      "archive_post": "ARCHIVOVAT PŘÍSPĚVEK",
      "archived_post": "ARCHIVOVÁNO",
      "post_is_published": "Příspěvek je uveřejněn",
      "post_is_not_published": "Příspěvek zatím nebyl uveřejněn",
      "post_is_archived": "Příspěvek je archivován",
      "update_post":"UPRAVIT PŘÍSPĚVEK",
      "add_contact": "Přidat kontakt",
      "edit_contact": "Upravit kontakt",
      "name_contact" : "Název kontaktu",
      "add_link": "Přidat odkaz",
      "edit_link": "Upravit odkaz",
      "name_link": "Název odkazu",
      "time_range_publication": "Časový rozsah uveřejnění (nepovinné)",
      "save_concept":"Uložit koncept",
      "textual": "Textový",
      "poster": "Plakát",
      "place": "Místo konání (nepovinné)",
      "placeEN": "Místo konání v angličtině",
      "detail_hint": "Pokud zadáváte vlastní název místa konání, musíte jej zadat také v angličtině. Chcete-li zadat čas novinky, musíte nejprve zadat datum novinky.",
      "date": "Datum konání (nepovinné)",
      "time": "Čas konání (nepovinné)",
      "something_went_wrong" : "Něco se pokazilo, zkuste to znovu.",
      "post_name":"Název příspěvku",
      "description":"Popis",
      "date_from": "Datum od",
      "date_to" : "Datum do",
      "enter": "VSTOUPIT",
      "what_post": "Jaký příspěvek hledáte?",
      "topic": "Téma",
      "part": "Součást",
      "target_group": "Cílová skupina",
      "edit": "UPRAVIT",
      "user_xlogin" : "xlogin uživatele",
      "user_name": "Jméno uživatele",
      "who_you_looking_for": "Koho hledáte?",
      "save": "Uložit",
      "cancel": "Zrušit",
      "post_hint":"Pro vytvoření příspěvku je nutné zadat název a popis v obou jazycích, vybrat alespoň jedno téma příspěvku a specifikovat cílovou skupinu a cílovou součast.",
      "user_exist": "Zadaný uživatel již existuje.",
      "delete_user": "Opravdu chcete smazat užívatele",
      "delete": "Opravdu chcete smazat",
      "statistics": "Statistiky",
      "statistics_subtitle": "Počty uživatelů, kterým se zobrazí novinky pro danou skupinu",
      "total_user" : "Uživatelů celkem",
      "total_user_text" : "Celkový počet uživatelů využívajících modul novinky",
      "audience_overview" : "Přehled skupin",
      "faculty_overview" : "Přehled fakult",
      "all_users" : "všech uživatelů",
      "no_data":"Žádná data",
      "hint_dialog": "Odkazy zadávejte ve formátu \"adresa.com\".",
      "placeholder_dialog": "adresa.com",
      "no_contacts_text": "Zatím nebyli přidány žádné kontaktní údaje.",
      "no_contacts_title": "Žádné kontakty.",
      "no_links_text": "Zatím nebyli přidány žádné odkazy.",
      "no_links_title": "Žádné odkazy.",
      "title_image": "Titulní obrázek",
      "confirm_deletion_img": "Opravdu chcete smazat tento obrázek natrvalo?",
      "confirm_cancel_upload": "Kliknutím na tlačítko 'OK' se smažou všechny obrázky, které právě nahráváte.",
      "info_images": "Doporučená velikost nahrávaných obrázků je do 5 MB, maximální limit je pak 15 MB. Pokud je vaše připojení pomalé, může ukládání obrázků trvat déle.",
      "info_images_upload": "Pokud nahrávání trvá příliš dlouho, zkontrolujte rychlost internetového připojení a velikost obrázku.",
      "notification_dialog_description": "Všem uživatelům mobilní aplikace Moje MENDELU bude zasláno oznámení. Pokud jste si jisti, že chcete uživatele znovu upozornit na tuto novinku, klikněte na tlačítko „Upozornit”. Pokud chcete upravit novinku bez upozornění uživatelů, klikněte na „Neupozornit”.",
      "notification_dialog_title": "Uložit a znovu upozornit uživatele?",
    },
    'warnings': {
      "statistics": "Statistiky",
      "statistics_subtitle": "Počty uživatelů, kterým se zobrazí důležité zprávy pro danou skupinu",
      "total_user" : "Uživatelů celkem",
      "total_user_text" : "Celkový počet uživatelů využívajících modul důležitých zpráv",
      "audience_overview" : "Přehled skupin",
      "all_users" : "všech uživatelů",
      "no_data": "Žádná data",
      "warnings": "Důležité zprávy",
    },

    'markdown': {
      "link_address_heading": "Adresa odkazu",
      "link_description": "Popis odkazu",
      "save_link": "Uložit odkaz",
      "final_markdown": "Výsledné formátování v nástroji Markdown",
      "tutorial_description1": "- Pro odsazení řádku je třeba zadat 2 mezery nebo prázdný řádek.",
      "tutorial_description2": "- Pro zrušení formátování je nutné znovu označit celý formátovaný úsek a znovu stisknout tlačítko, jehož stylování chcete zrušit.",
      "tutorial_description3": "- Pro rychlejší formátování můžete použít klávesové zkratky jako Ctrl + B pro tučné písmo nebo Ctrl + I pro kurzívu",
      "no_text_selected": "Nebyl vybrán žádný text",
      "incorrect_address": "Neplatná adresa",
      "example_link_address": "https://odkaz.cz",
      "bold": "Tučné",
      "italic": "Kurzíva",
      "strike": "Přeškrtnuté",
      "link": "Odkaz",
      "subheading": "Podnadpis",
    },

    'time_picker': {
      "bad_time_format": "Špatný formát. Prosím uveďte čas ve formátu 06:30",
      "bad_time_range": "Čas je zadaný ve špatném rozsahu. Prosím zadejte čas v rozsahu ",
      "required": "Povinné",
    }

}
